module.exports = __webpack_public_path__ + "img/check.500381d.png";